<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Shipping Group</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <edit-shipping-group v-if="isSameGroup"></edit-shipping-group>
            <create-shipping-group v-else-if="hasNoGroup"></create-shipping-group>
            <section class="modal-card-body" v-else>
                <h1>Select cars with same group or without group.</h1>
            </section>
            <footer class="modal-card-foot">
                <button class="button" @click="closeModal">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import apiUsers from '../../../../../api/apiUsers'
    import apiShippingGroup from '../../../../../api/apiShippingGroups'
    import createShippingGroup from '../../../../Cars/ShippingGroup/CreateShippingGroup.vue'
    import editShippingGroup from '../../../../Cars/ShippingGroup/EditShippingGroup.vue'
    export default {
        components:{
            createShippingGroup,
            editShippingGroup
        },
        data() {
            return {
                submitDisabled: true,
                isLoading: false,
                carIds: []
            }
        },
        computed: {
            isActive: function () {
                return this.$store.getters.getShippingGroupModalStatus
            },
            isSameGroup() {
                let cars = this.$store.getters.getShippingGroupFullCars
                let ids = []
                cars.forEach(function (car) {
                    ids.push(car.shipping_group_id)
                })
                let status = false
                if (cars.length > 0){
                    if (cars[0].shipping_group_id > 0) {
                        status = ids.every((val, i, arr) => val === arr[0] )
                    }
                }
                if (status && cars.length > 0) {
                    if (cars[0].shipping_group_id > 0){
                        this.$store.dispatch('changeShippingGroupName', cars[0].shipping_group.name)
                        this.$store.dispatch('updateShippingGroupId', cars[0].shipping_group.id)
                    }
                }
                return status
            },
            hasNoGroup() {
                let cars = this.$store.getters.getShippingGroupFullCars
                let ids = []
                cars.forEach(function (car) {
                    ids.push(car.shipping_group_id)
                })
                return ids.every((val, i, arr) => val === null )
            }
        },
        methods: {
            closeModal() {
                this.$store.dispatch('changeShippingGroupDataToDefault')
                this.$store.dispatch('changeShippingGroupModalStatus', false)
            }
        },
        mounted () {
            apiUsers
                .userRequest(this.$route.params.id)
                .then((response) => {
                    this.$store.dispatch('updateShippingGroupUserName', response.data.name)
                    this.$store.dispatch('changeShippingGroupUserId', response.data.id)
                })
                .catch((error) => {

                })
        }
    }
</script>

<style scoped>
    .image {
        padding-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/Garage/ShippingGroupModal.vue